<template>
  <div class="space-y-4">
    <div class="text-sm font-medium text-gray-700">{{ title }}</div>
    <div class="text-sm text-gray-500">{{ description }}</div>
    
    <el-upload
      class="upload-demo"
      drag
      ref="uploadRef"
      :http-request="customRequest"
      :multiple="true"
      :show-file-list="true"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
    >
      <el-icon class="el-icon--upload"><upload-filled /></el-icon>
      <div class="el-upload__text">
        将文件拖到此处，或<em>点击上传</em>
      </div>
      <template #tip>
        <div class="el-upload__tip">
          支持 jpg/png/pdf/doc/docx 格式文件，单个文件大小不超过 10MB
        </div>
      </template>
    </el-upload>
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { ElMessage } from 'element-plus'
import { uploadFile } from '../../api/upload'

defineProps({
  title: {
    type: String,
    default: '文件上传'
  },
  description: {
    type: String,
    default: '请上传相关文件'
  }
})

const emit = defineEmits(['success', 'error', 'change'])
const uploadRef = ref(null)

const beforeUpload = (file) => {
  const isValidType = ['image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)
  const isLt10M = file.size / 1024 / 1024 < 10

  if (!isValidType) {
    ElMessage.error('上传文件只能是 JPG/PNG/PDF/DOC/DOCX 格式!')
    return false
  }
  if (!isLt10M) {
    ElMessage.error('上传文件大小不能超过 10MB!')
    return false
  }
  return true
}

const customRequest = async (options) => {
  const { file, onSuccess, onError } = options
  try {
    const url = await uploadFile(file)
    const cleanUrl = String(url || '').trim().replace(/^`+|`+$/g, '')
    onSuccess?.({ url: cleanUrl })
    ElMessage.success(`${file.name} 上传成功!`)
    emit('success', { file, url: cleanUrl })
    emit('change', { file, url: cleanUrl, type: 'add' })
  } catch (e) {
    onError?.(e)
    ElMessage.error(`${file.name} 上传失败!`)
    emit('error', { file, error: e })
  }
}

const handleRemove = (file) => {
  ElMessage.info(`已删除 ${file.name}`)
  // 变更事件携带删除标记与可能的地址
  const url = file?.response?.url
  emit('change', { file, url, type: 'remove' })
}

const clear = () => {
  try { uploadRef.value?.clearFiles?.() } catch { void 0 }
}

defineExpose({ clear })
</script>

<style scoped>
.upload-demo {
  width: 100%;
}
</style>